module.exports = "../images/icons-race-details/Campanella.svg";